import FJNetworkStore from "./FJNetworkStore";
import FJCoreConstant from "../core/constant/FJCoreConstant";
import FJViewConstant from "../constant/FJViewConstant";
import FJConfig from "../config/FJConfig";

let FJBackgroundStore = (function () {

  let _list = [
    {
      category: "Abstract Background",
      searchKey: "abstract background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Solid Color Background",
      type: "color",
      total: 11,
      list: [
        '#000000',
        '#FFFFFF',
        '#7A85EB',
        '#9DCAC9',
        '#C8577D',
        '#F79C5B',
        '#245C95',
        '#018EA1',
        '#AACF70',
        '#018E75',
        '#C899C5'
      ],
    },
    {
      category: "Technology Background",
      searchKey: "abstract technology background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Effect Background",
      searchKey: "effect background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Gradient Photo Background",
      type: "image",
      total: 58,
      list: [
        {imageUrl: "gradient-photo-background-0001", ext: "png"},
        {imageUrl: "gradient-photo-background-0002", ext: "png"},
        {imageUrl: "gradient-photo-background-0003", ext: "png"},
        {imageUrl: "gradient-photo-background-0004", ext: "png"},
        {imageUrl: "gradient-photo-background-0005", ext: "png"},
        {imageUrl: "gradient-photo-background-0006", ext: "png"},
        {imageUrl: "gradient-photo-background-0007", ext: "png"},
        {imageUrl: "gradient-photo-background-0008", ext: "png"},
        {imageUrl: "gradient-photo-background-0009", ext: "png"},
        {imageUrl: "gradient-photo-background-0010", ext: "png"},
        {imageUrl: "gradient-photo-background-0011", ext: "png"},
        {imageUrl: "gradient-photo-background-0012", ext: "png"},
        {imageUrl: "gradient-photo-background-0013", ext: "png"},
        {imageUrl: "gradient-photo-background-0014", ext: "png"},
        {imageUrl: "gradient-photo-background-0015", ext: "png"},
        {imageUrl: "gradient-photo-background-0016", ext: "png"},
        {imageUrl: "gradient-photo-background-0017", ext: "png"},
        {imageUrl: "gradient-photo-background-0018", ext: "png"},
        {imageUrl: "gradient-photo-background-0019", ext: "png"},
        {imageUrl: "gradient-photo-background-0020", ext: "png"},
        {imageUrl: "gradient-photo-background-0021", ext: "png"},
        {imageUrl: "gradient-photo-background-0022", ext: "png"},
        {imageUrl: "gradient-photo-background-0023", ext: "png"},
        {imageUrl: "gradient-photo-background-0024", ext: "png"},
        {imageUrl: "gradient-photo-background-0025", ext: "png"},
        {imageUrl: "gradient-photo-background-0026", ext: "png"},
        {imageUrl: "gradient-photo-background-0027", ext: "png"},
        {imageUrl: "gradient-photo-background-0028", ext: "png"},
        {imageUrl: "gradient-photo-background-0029", ext: "png"},
        {imageUrl: "gradient-photo-background-0030", ext: "png"},
        {imageUrl: "gradient-photo-background-0031", ext: "png"},
        {imageUrl: "gradient-photo-background-0032", ext: "png"},
        {imageUrl: "gradient-photo-background-0033", ext: "png"},
        {imageUrl: "gradient-photo-background-0034", ext: "png"},
        {imageUrl: "gradient-photo-background-0035", ext: "png"},
        {imageUrl: "gradient-photo-background-0036", ext: "png"},
        {imageUrl: "gradient-photo-background-0037", ext: "png"},
        {imageUrl: "gradient-photo-background-0038", ext: "png"},
        {imageUrl: "gradient-photo-background-0039", ext: "png"},
        {imageUrl: "gradient-photo-background-0040", ext: "png"},
        {imageUrl: "gradient-photo-background-0041", ext: "png"},
        {imageUrl: "gradient-photo-background-0042", ext: "png"},
        {imageUrl: "gradient-photo-background-0043", ext: "png"},
        {imageUrl: "gradient-photo-background-0044", ext: "png"},
        {imageUrl: "gradient-photo-background-0045", ext: "png"},
        {imageUrl: "gradient-photo-background-0046", ext: "png"},
        {imageUrl: "gradient-photo-background-0047", ext: "png"},
        {imageUrl: "gradient-photo-background-0048", ext: "png"},
        {imageUrl: "gradient-photo-background-0049", ext: "png"},
        {imageUrl: "gradient-photo-background-0050", ext: "png"},
        {imageUrl: "gradient-photo-background-0051", ext: "png"},
        {imageUrl: "gradient-photo-background-0052", ext: "png"},
        {imageUrl: "gradient-photo-background-0053", ext: "png"},
        {imageUrl: "gradient-photo-background-0054", ext: "png"},
        {imageUrl: "gradient-photo-background-0055", ext: "png"},
        {imageUrl: "gradient-photo-background-0056", ext: "png"},
        {imageUrl: "gradient-photo-background-0057", ext: "png"},
        {imageUrl: "gradient-photo-background-0058", ext: "png"},
      ],
    },
    {
      category: "Geometric Background",
      searchKey: "geometric background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Light Background",
      searchKey: "light background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Photo Background",
      type: "image",
      total: 262,
      list: [
        {"imageUrl": "photo-background-0001", "ext": "jpg"},
        {"imageUrl": "photo-background-0002", "ext": "jpg"
        }, {"imageUrl": "photo-background-0003", "ext": "jpg"}, {
          "imageUrl": "photo-background-0004",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0005", "ext": "jpg"}, {
          "imageUrl": "photo-background-0006",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0007", "ext": "jpg"}, {
          "imageUrl": "photo-background-0008",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0009", "ext": "jpg"}, {
          "imageUrl": "photo-background-0010",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0011", "ext": "jpg"}, {
          "imageUrl": "photo-background-0012",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0013", "ext": "jpg"}, {
          "imageUrl": "photo-background-0014",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0015", "ext": "jpg"}, {
          "imageUrl": "photo-background-0016",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0017", "ext": "jpg"}, {
          "imageUrl": "photo-background-0018",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0019", "ext": "jpg"}, {
          "imageUrl": "photo-background-0020",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0021", "ext": "jpg"}, {
          "imageUrl": "photo-background-0022",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0023", "ext": "jpg"}, {
          "imageUrl": "photo-background-0024",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0025", "ext": "jpg"}, {
          "imageUrl": "photo-background-0026",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0027", "ext": "jpg"}, {
          "imageUrl": "photo-background-0028",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0029", "ext": "jpg"}, {
          "imageUrl": "photo-background-0030",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0031", "ext": "jpg"}, {
          "imageUrl": "photo-background-0032",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0033", "ext": "jpg"}, {
          "imageUrl": "photo-background-0034",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0035", "ext": "jpg"}, {
          "imageUrl": "photo-background-0036",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0037", "ext": "jpg"}, {
          "imageUrl": "photo-background-0038",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0039", "ext": "jpg"}, {
          "imageUrl": "photo-background-0040",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0041", "ext": "jpg"}, {
          "imageUrl": "photo-background-0042",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0043", "ext": "jpg"}, {
          "imageUrl": "photo-background-0044",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0045", "ext": "jpg"}, {
          "imageUrl": "photo-background-0046",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0047", "ext": "jpg"}, {
          "imageUrl": "photo-background-0048",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0049", "ext": "jpg"}, {
          "imageUrl": "photo-background-0050",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0051", "ext": "jpg"}, {
          "imageUrl": "photo-background-0052",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0053", "ext": "jpg"}, {
          "imageUrl": "photo-background-0054",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0055", "ext": "jpg"}, {
          "imageUrl": "photo-background-0056",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0057", "ext": "jpg"}, {
          "imageUrl": "photo-background-0058",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0059", "ext": "jpg"}, {
          "imageUrl": "photo-background-0060",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0061", "ext": "jpg"}, {
          "imageUrl": "photo-background-0062",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0063", "ext": "jpg"}, {
          "imageUrl": "photo-background-0064",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0065", "ext": "jpg"}, {
          "imageUrl": "photo-background-0066",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0067", "ext": "jpg"}, {
          "imageUrl": "photo-background-0068",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0069", "ext": "jpg"}, {
          "imageUrl": "photo-background-0070",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0071", "ext": "jpg"}, {
          "imageUrl": "photo-background-0072",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0073", "ext": "jpg"}, {
          "imageUrl": "photo-background-0074",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0075", "ext": "jpg"}, {
          "imageUrl": "photo-background-0076",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0077", "ext": "jpg"}, {
          "imageUrl": "photo-background-0078",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0079", "ext": "jpg"}, {
          "imageUrl": "photo-background-0080",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0081", "ext": "jpg"}, {
          "imageUrl": "photo-background-0082",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0083", "ext": "jpg"}, {
          "imageUrl": "photo-background-0084",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0085", "ext": "jpg"}, {
          "imageUrl": "photo-background-0086",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0087", "ext": "jpg"}, {
          "imageUrl": "photo-background-0088",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0089", "ext": "jpg"}, {
          "imageUrl": "photo-background-0090",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0091", "ext": "jpg"}, {
          "imageUrl": "photo-background-0092",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0093", "ext": "jpg"}, {
          "imageUrl": "photo-background-0094",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0095", "ext": "jpg"}, {
          "imageUrl": "photo-background-0096",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0097", "ext": "jpg"}, {
          "imageUrl": "photo-background-0098",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0099", "ext": "jpg"}, {
          "imageUrl": "photo-background-0100",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0101", "ext": "jpg"}, {
          "imageUrl": "photo-background-0102",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0103", "ext": "jpg"}, {
          "imageUrl": "photo-background-0104",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0105", "ext": "jpg"}, {
          "imageUrl": "photo-background-0106",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0107", "ext": "jpg"}, {
          "imageUrl": "photo-background-0108",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0109", "ext": "jpg"}, {
          "imageUrl": "photo-background-0110",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0111", "ext": "jpg"}, {
          "imageUrl": "photo-background-0112",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0113", "ext": "jpg"}, {
          "imageUrl": "photo-background-0114",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0115", "ext": "jpg"}, {
          "imageUrl": "photo-background-0116",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0117", "ext": "jpg"}, {
          "imageUrl": "photo-background-0118",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0119", "ext": "jpg"}, {
          "imageUrl": "photo-background-0120",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0121", "ext": "jpg"}, {
          "imageUrl": "photo-background-0122",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0123", "ext": "jpg"}, {
          "imageUrl": "photo-background-0124",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0125", "ext": "jpg"}, {
          "imageUrl": "photo-background-0126",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0127", "ext": "jpg"}, {
          "imageUrl": "photo-background-0128",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0129", "ext": "jpg"}, {
          "imageUrl": "photo-background-0130",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0131", "ext": "jpg"}, {
          "imageUrl": "photo-background-0132",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0133", "ext": "jpg"}, {
          "imageUrl": "photo-background-0134",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0135", "ext": "jpg"}, {
          "imageUrl": "photo-background-0136",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0137", "ext": "jpg"}, {
          "imageUrl": "photo-background-0138",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0139", "ext": "jpg"}, {
          "imageUrl": "photo-background-0140",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0141", "ext": "jpg"}, {
          "imageUrl": "photo-background-0142",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0143", "ext": "jpg"}, {
          "imageUrl": "photo-background-0144",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0145", "ext": "jpg"}, {
          "imageUrl": "photo-background-0146",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0147", "ext": "jpg"}, {
          "imageUrl": "photo-background-0148",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0149", "ext": "jpg"}, {
          "imageUrl": "photo-background-0150",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0151", "ext": "jpg"}, {
          "imageUrl": "photo-background-0152",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0153", "ext": "jpg"}, {
          "imageUrl": "photo-background-0154",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0155", "ext": "jpg"}, {
          "imageUrl": "photo-background-0156",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0157", "ext": "jpg"}, {
          "imageUrl": "photo-background-0158",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0159", "ext": "jpg"}, {
          "imageUrl": "photo-background-0160",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0161", "ext": "jpg"}, {
          "imageUrl": "photo-background-0162",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0163", "ext": "jpg"}, {
          "imageUrl": "photo-background-0164",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0165", "ext": "jpg"}, {
          "imageUrl": "photo-background-0166",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0167", "ext": "jpg"}, {
          "imageUrl": "photo-background-0168",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0169", "ext": "jpg"}, {
          "imageUrl": "photo-background-0170",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0171", "ext": "jpg"}, {
          "imageUrl": "photo-background-0172",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0173", "ext": "jpg"}, {
          "imageUrl": "photo-background-0174",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0175", "ext": "jpg"}, {
          "imageUrl": "photo-background-0176",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0177", "ext": "jpg"}, {
          "imageUrl": "photo-background-0178",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0179", "ext": "jpg"}, {
          "imageUrl": "photo-background-0180",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0181", "ext": "jpg"}, {
          "imageUrl": "photo-background-0182",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0183", "ext": "jpg"}, {
          "imageUrl": "photo-background-0184",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0185", "ext": "jpg"}, {
          "imageUrl": "photo-background-0186",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0187", "ext": "jpg"}, {
          "imageUrl": "photo-background-0188",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0189", "ext": "jpg"}, {
          "imageUrl": "photo-background-0190",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0191", "ext": "jpg"}, {
          "imageUrl": "photo-background-0192",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0193", "ext": "jpg"}, {
          "imageUrl": "photo-background-0194",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0195", "ext": "jpg"}, {
          "imageUrl": "photo-background-0196",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0197", "ext": "jpg"}, {
          "imageUrl": "photo-background-0198",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0199", "ext": "jpg"}, {
          "imageUrl": "photo-background-0200",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0201", "ext": "jpg"}, {
          "imageUrl": "photo-background-0202",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0203", "ext": "jpg"}, {
          "imageUrl": "photo-background-0204",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0205", "ext": "jpg"}, {
          "imageUrl": "photo-background-0206",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0207", "ext": "jpg"}, {
          "imageUrl": "photo-background-0208",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0209", "ext": "jpg"}, {
          "imageUrl": "photo-background-0210",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0211", "ext": "jpg"}, {
          "imageUrl": "photo-background-0212",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0213", "ext": "jpg"}, {
          "imageUrl": "photo-background-0214",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0215", "ext": "jpg"}, {
          "imageUrl": "photo-background-0216",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0217", "ext": "jpg"}, {
          "imageUrl": "photo-background-0218",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0219", "ext": "jpg"}, {
          "imageUrl": "photo-background-0220",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0221", "ext": "jpg"}, {
          "imageUrl": "photo-background-0222",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0223", "ext": "jpg"}, {
          "imageUrl": "photo-background-0224",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0225", "ext": "jpg"}, {
          "imageUrl": "photo-background-0226",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0227", "ext": "jpg"}, {
          "imageUrl": "photo-background-0228",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0229", "ext": "jpg"}, {
          "imageUrl": "photo-background-0230",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0231", "ext": "jpg"}, {
          "imageUrl": "photo-background-0232",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0233", "ext": "jpg"}, {
          "imageUrl": "photo-background-0234",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0235", "ext": "jpg"}, {
          "imageUrl": "photo-background-0236",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0237", "ext": "jpg"}, {
          "imageUrl": "photo-background-0238",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0239", "ext": "jpg"}, {
          "imageUrl": "photo-background-0240",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0241", "ext": "jpg"}, {
          "imageUrl": "photo-background-0242",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0243", "ext": "jpg"}, {
          "imageUrl": "photo-background-0244",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0245", "ext": "jpg"}, {
          "imageUrl": "photo-background-0246",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0247", "ext": "jpg"}, {
          "imageUrl": "photo-background-0248",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0249", "ext": "jpg"}, {
          "imageUrl": "photo-background-0250",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0251", "ext": "jpg"}, {
          "imageUrl": "photo-background-0252",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0253", "ext": "jpg"}, {
          "imageUrl": "photo-background-0254",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0255", "ext": "jpg"}, {
          "imageUrl": "photo-background-0256",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0257", "ext": "jpg"}, {
          "imageUrl": "photo-background-0258",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0259", "ext": "jpg"}, {
          "imageUrl": "photo-background-0260",
          "ext": "jpg"
        }, {"imageUrl": "photo-background-0261", "ext": "jpg"}, {
          "imageUrl": "photo-background-0262",
          "ext": "jpg"
        }
      ],
    },
    {
      category: "Gold Background",
      searchKey: "gold background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Texture Background",
      searchKey: "texture background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Flower Background",
      searchKey: "flower background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Gradient Background",
      searchKey: "gradient background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Heart Background",
      searchKey: "abstract heart background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Polygon Background",
      searchKey: "polygon background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Nature Background",
      searchKey: "nature background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Color Background",
      searchKey: "color background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Simple Background",
      searchKey: "simple background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    },
    {
      category: "Cartoon Background",
      searchKey: "cartoon background",
      type: "video",
      status: "",
      total: 0,
      page: 1,
      list: [],
    }
  ];

  function getItemData(type, id) {
    for (let i = 0; i < _list.length; i++) {
      const {type: iType, list, category} = _list[i];
      if (type === iType) {
        switch (type) {
          case 'image': {
            let item = list.find(i => i.imageUrl === id);
            if (item) {
              return {item, category};
            }
            break;
          }
          case 'video': {
            let item = list.find(i => i.id === id);
            if (item) {
              return {item, category};
            }
            break;
          }
        }
      }
    }
  }

  function getCategory(category) {
    return _list.find(item => item.category === category);
  }

  return {
    init: function (callback) {
      _list.forEach(item => {
        if (item.type === 'video') {
          let {searchKey} = item;
          let {status} = item;
          if (status && status !== FJViewConstant.STOCK_SEARCH_ERROR) {
            return;
          }
          item.status = FJViewConstant.STOCK_SEARCH_LOADING;
          callback([..._list]);
          FJNetworkStore.searchMedias({
            type: FJCoreConstant.VIDEO,
            sortType: FJViewConstant.SORT_TYPE_RELEVANT,
            keywords: searchKey,
          })
            .then(data => {
              item.total = data[1];

              // eslint-disable-next-line max-nested-callbacks
              item.list = data[0].map(it => {
                return {
                  ...it,
                  thumbnail: it.thumbnail_url,
                  url: it.preview_url_small,
                };
              });
              item.status = FJViewConstant.STOCK_SEARCH_SUCCESS;
            }).catch(e => {
            console.log(e);
            item.status = FJViewConstant.STOCK_SEARCH_ERROR;
          }).finally(() => {
            callback([..._list]);
          })
        }
      });
    },

    nextPage: function (category, callback) {
      let categoryData = getCategory(category);
      let {searchKey, page} = categoryData;
      let curPage = page + 1;
      categoryData.status = FJViewConstant.STOCK_SEARCH_SUBLOADING;
      callback([..._list]);
      FJNetworkStore.searchMedias({
        type: FJCoreConstant.VIDEO,
        sortType: FJViewConstant.SORT_TYPE_RELEVANT,
        keywords: searchKey,
        page: curPage,
      })
        .then(data => {

          // eslint-disable-next-line max-nested-callbacks
          let list = data[0].map(it => {
            return {
              ...it,
              thumbnail: it.thumbnail_url,
              url: it.preview_url_small,
            };
          });
          categoryData.page = curPage;
          categoryData.list = categoryData.list.concat(list);
          callback([..._list]);
        }).catch(e => {
        console.log(e);
      }).finally(() => {
        categoryData.status = FJViewConstant.STOCK_SEARCH_SUCCESS;
        callback([..._list]);
      })
    },

    getUrls: function (type, id) {
      let {photoBackgroundPath} = FJConfig;
      let data = getItemData(type, id);
      if (data) {
        let {item, category} = data;
        switch (type) {
          case 'image': {
            let chunk0 = `${photoBackgroundPath}/${category.replace(/ /g, "-").toLowerCase()}`;
            let chunk1 = '-thumbnail/';
            let chunk2 = '/';
            let chunk3 = `${item.imageUrl}.${item.ext}`;
            return {
              url: chunk0 + chunk2 + chunk3,
              thumbnail: chunk0 + chunk1 + chunk3,
            };
          }
          case 'video':
            return {
              url: item.url,
              thumbnail: item.thumbnail,
            }
        }
      }
    },

    get list() {
      return _list;
    },
  }
})();

export default FJBackgroundStore;